export const ACH = 'ACH';
export const CREDIT_CARD = 'CREDIT_CARD';
export const FINANCING = 'FINANCING';
export const PURCHASE_ORDER = 'PURCHASE_ORDER';
export const PAYPAL = 'PAYPAL';
